<template>
    <Core
        :avatar="avatar"
        :nickname="nickname"
        :avatarSize="avatarSize"
        :avatarMarginRight="avatarMarginRight"
        :layout="layout"
    />
</template>

<script>
/* eslint-disable vue/multi-word-component-names */
import Core from './core';
import { query2obj } from './utils.js';
import { NICKNAME_PLACEHOLDER, INVITER_SOURCE, LAYOUT } from '../constant/enum.js';
const {
    common: {
        request: { bindCommonApi }
    },
    store: { variable }
} = require('@futuweb/fego-render');

const commonApiRequest = bindCommonApi('inviter');

export default {
    name: 'inviter',
    components: {
        Core
    },
    props: {
        displayAvatar: {
            type: Boolean,
            default: true
        },
        avatarSize: {
            type: Number
        },
        avatarMarginRight: {
            type: Number
        },
        defaultAvatar: {
            type: String,
            default: ''
        },
        nameFormat: {
            type: String,
            default: ''
        },
        noInviterDisplayAvatar: {
            type: Boolean,
            default: false
        },
        noInviterAvatar: {
            type: String,
            default: ''
        },
        noInviterText: {
            type: String,
            default: ''
        },
        inviterSource: {
            type: String,
            default: INVITER_SOURCE.GLOBAL_CONTENT
        },
        inviterSourceKey: {
            type: String,
            default: ''
        },
        layout: {
            type: String,
            default: LAYOUT.HORIZONTAL
        }
    },
    data() {
        return {
            avatar: '',
            nickname: ''
        };
    },
    async created() {
        await this.getInviter();
        if (!this.nickname) {
            this.avatar = this.noInviterDisplayAvatar ? this.noInviterAvatar : '';
            this.nickname = this.noInviterText;
        }
    },
    methods: {
        initGlobalContent(global_content) {
            if (!global_content) {
                return;
            }

            try {
                const json = JSON.parse(global_content);
                if (json.promote_id || json.invite) {
                    return {
                        invite: json.invite,
                        promote_id: json.promote_id,
                        sub_promote_id: json.sub_promote_id || 1
                    };
                }
            } catch (error) {
                console.log(error);
            }
        },
        // 初始化参数
        initParams() {
            if (this.inviterSource === INVITER_SOURCE.CURRENT_USER) {
                const uid = variable.data.UID;
                if (!uid) {
                    return null;
                }
                return { invite: uid };
            }

            const query = query2obj();
            // 从归因参数(invite)获取
            if (this.inviterSource === INVITER_SOURCE.GLOBAL_CONTENT_INVITE) {
                const globalContent = this.initGlobalContent(query.global_content);
                const invite = globalContent?.invite;
                if (invite !== null && invite !== '' && /^\d+$/.test(String(invite))) {
                    return { invite: String(invite) };
                }
                return null;
            }
            // 默认从归因参数获取
            if (!this.inviterSource || this.inviterSource === INVITER_SOURCE.GLOBAL_CONTENT) {
                const globalContent = this.initGlobalContent(query.global_content);
                if (globalContent) {
                    return globalContent;
                }
                return;
            }
            const invite = query[this.inviterSourceKey];
            if (invite) {
                return {
                    invite
                };
            }
        },
        async getInviter() {
            const params = this.initParams();
            if (!params) {
                return;
            }
            const queryParams = {};
            if (params.invite) {
                queryParams.invite = params.invite;
            }
            if (params.promote_id) {
                queryParams.promote_id = params.promote_id;
                queryParams.sub_promote_id = params.sub_promote_id || 1;
            }
            if (Object.keys(queryParams).length === 0) {
                return;
            }

            const inviter = await commonApiRequest.get('inviter', queryParams);
            if (!inviter || !inviter.nickname) {
                return;
            }

            this.avatar = this.displayAvatar ? inviter.avatar || this.defaultAvatar : '';
            this.nickname = this.nameFormat.replace(NICKNAME_PLACEHOLDER, inviter.nickname);
        }
    }
};
</script>
